export default "__VITE_ASSET__3c22aec7__"